<template>
    <div class="public_container add_project_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
            <div class="mobile_head_operate" v-if="projectDetail.status == 0">
                <van-popover v-model="headOperatePopoverShow" trigger="click" placement="bottom-end">
                    <ul class="head_operate_popover_list">
                        <li v-for="item in headOperateActionsList" @click="handleClickHeadOperate(item)">
                            <i :class="item.icon"></i> <span v-text="item.text"></span>
                            <ul class="head_operate_popover_list child_head_operate_popover_list" v-if="headOperateType == item.value && item.children">
                                <li v-for="child in item.children" @click.stop="handleClickHeadOperate(child)">
                                   <span v-text="child.text"></span>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <template #reference>
                        <span><i class="iconfont icon-a-tianjiamiaobian"></i></span>
                    </template>
                </van-popover>
            </div>
        </div>
        <div class="mobile_container project_detail_container">
            <div class="project_detail_base" @click="projectBaseDetailPopupShow = true">
                <van-icon class="is_link_right" name="arrow" />
                <div class="title_wrap">
                    <h5 class="ellipsis" v-text="projectDetail.project_manage_name"></h5>
                    <span class="status_wrap">
                        <span class="status_text status0" v-if="projectDetail.status == 0 ">进行中</span>
                        <span class="status_text status1" v-if="projectDetail.status == 1 ">已完结</span>
                        <span class="status_text status2" v-if="projectDetail.status == 2" >已关闭</span>
                    </span>
                </div>
                <div class="user_time_wrap">
                      <span class="mobile_head_user" v-if="projectDetail.head_user" @click="handleClickRelateHandle('user_detail',{uid:projectDetail.head_user.id})">
                          <img :src="projectDetail.head_user.avatar ? projectDetail.head_user.avatar : defaultImg" alt="">
                          <span class="ellipsis" v-text="projectDetail.head_user.name"></span>
                     </span>
                      <span class="line"></span>
                      <span class="time" v-if="projectDetail.created_at" v-text="projectDetail.updated_at.substring(0, 10)"></span>
                      <span class="time" v-if="projectDetail.status > 0 &&  projectDetail.end_date" v-text="'— '+ projectDetail.end_date.substring(0, 10)"></span>
                </div>
            </div>

            <div class="project_detail_tabs">
                <div class="project_detail_tabs_scroll">
                    <span :class="activeName == item.value ? 'active' : ''" v-for="item in tabList" v-text="item.title" @click="handleClickTab(item)"></span>
                </div>
            </div>

            <div class="project_detail_content_wrap">

                <div class="project_board_wrap" v-if="activeName == 'project_board'">
                    <div class="project_board_progress">
                        <div class="project_board_progress_top">
                            <div>
                                <h5>项目进度</h5>
                                <span>根据日期自动匹配项目进度</span>
                            </div>
                            <van-icon @click="projectProgressPopupShow = true" class="is_link_right" name="arrow" />
                        </div>
                        <div class="project_board_progress_bottom">
                            <ul>
                                <li>
                                    <div class="record_time">
                                        <div class="time"></div>
                                        <span></span>
                                    </div>
                                    <div class="record_content">
                                        <div class="record_item">开始</div>
                                    </div>
                                </li>
                                <li v-for="item in logList">
                                    <div class="record_time">
                                        <div class="time" v-text="item.date"></div>
                                        <span></span>
                                    </div>
                                    <div class="record_content">
                                        <div class="record_item" v-for="log in item.logs">
                                            <div v-if="log.type == 'custom'">
                                                <div v-html="log.user.name + '：' + log.content.text + updatedDate(item.date,log.updated_at)"></div>
                                            </div>
                                            <div v-else>
                                                <span v-text="getLogDescriptions(log).title"></span>
                                                <span @click="handleClickRelateHandle(getLogDescriptions(log).handle_type,getLogDescriptions(log).info)" class="link-label" v-text="getLogDescriptions(log).relate_num"></span>
                                                <span v-text="getLogDescriptions(log).content_text"></span>
                                                <span class="link-label" v-if="getLogDescriptions(log).derivative_num" v-text="getLogDescriptions(log).derivative_num" @click="handleClickRelateHandle(getLogDescriptions(log).derivative_handle_type,getLogDescriptions(log).derivative)"></span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="record_time">
                                        <div class="time"></div>
                                        <span></span>
                                    </div>
                                    <div class="record_content">
                                        <div class="record_item"  v-if="projectDetail.status == 1">完结</div>
                                        <div class="record_item"  v-if="projectDetail.status == 2">关闭</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="project_board_finance">
                        <div class="project_board_finance_top">
                            <div class="project_board_finance_top_left">
                                <span :class="board_financial_tab == 'income' ? 'active': ''" @click="handleClickBoardFinancialTab('income')">项目收入</span>
                                <span v-if="userPermission.includes('all') || userPermission.includes('financial_profit')" :class="board_financial_tab == 'cost' ? 'active': ''" @click="handleClickBoardFinancialTab('cost')">项目成本</span>
                            </div>
                            <div class="project_board_finance_top_right">
                                <span v-if="board_financial_tab == 'income'" @click="handleClickTost('项目实际利润＝实际回款总金额 - 项目成本总金额')" class="link-label"><i class="iconfont icon-shuoming"></i></span>
                                <span v-if="board_financial_tab == 'cost' && projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('financial_cost'))" @click="handleClickAddCost" class="link-label"><i class="iconfont icon-tianjia1 mr_4"></i>新建成本</span>
                            </div>
                        </div>
                        <div class="project_board_finance_bottom">
                            <div class="project_board_finance_income_content"  v-if="board_financial_tab == 'income'">
                                <div class="project_board_finance_income_left">
                                    <div class="project_board_finance_income_left_item">
                                        项目订单总金额：{{financialBoardData.board.totalPrice}}
                                    </div>
                                    <div class="project_board_finance_income_left_item">
                                        实际回款总金额：{{financialBoardData.board.repayPrice}}
                                    </div>
                                    <div class="project_board_finance_income_left_item">
                                        待回款总金额：{{financialBoardData.board.noRepayPrice }}
                                    </div>
                                    <div class="project_board_finance_income_left_item">
                                        采购退款金额：{{financialBoardData.board.purchaseRefundPrice}}
                                    </div>
                                    <div class="project_board_finance_income_left_item project_board_finance_income_left_item_bold" v-if="userPermission.includes('all') || userPermission.includes('financial_profit')">
                                        项目实际利润 ：{{financialBoardData.board.profit}}
                                    </div>

                                </div>
                                <div class="project_board_finance_income_right">
                                    <el-progress type="circle" :percentage="financialBoardData.repayPricePercentage" :stroke-width="8" :width="100" :show-text="false"></el-progress>
                                    <div class="project_board_finance_income_right_text">
                                        <h5>{{financialBoardData.repayPricePercentage}}%</h5>
                                        <p>已回款</p>
                                    </div>
                                </div>
                            </div>

                            <div class="project_board_finance_cost_content" v-if="board_financial_tab == 'cost'">
                                <div class="project_board_finance_cost_content_top">
                                    <div>项目总成本：{{financialBoardData.totalCost}}</div>
                                    <ul class="project_list_type_list">
                                        <li :class="{'active':costMode==='pie'}" class="project_list_type_item"  @click="handleClickCostCharts('pie')">
                                            <i class="iconfont icon-bingtu"></i>
                                        </li>
                                        <li :class="{'active':costMode==='bar'}" class="project_list_type_item"  @click="handleClickCostCharts('bar')">
                                            <i class="iconfont icon-zhuzhuangtu"></i>
                                        </li>
                                    </ul>
                                </div>
                                <div class="project_board_finance_cost_content_bottom">
                                    <template v-if="costMode === 'pie'">
                                        <div class="echarts_container" id="container1"></div>
                                    </template>
                                    <template v-if="costMode === 'bar'">
                                        <div class="echarts_container" id="container2"></div>
                                    </template>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="business_related_wrap" v-if="activeName =='business_related'">
                    <div class="tab_nav_list">
                        <span @click="handleClickRelatedTab('business')" :class="{'active' : relatedTabActive == 'business'}">商机 <i v-text="projectDetail.business_number"></i></span>
                        <span @click="handleClickRelatedTab('order')" :class="{'active' : relatedTabActive == 'order'}">订单 <i v-text="projectDetail.order_number"></i></span>
                        <span @click="handleClickRelatedTab('work_order')" :class="{'active' : relatedTabActive == 'work_order'}">工单 <i v-text="projectDetail.work_order_number"></i></span>
                    </div>

                    <div class="related_max_height_wrap">
                        <div class="related_search_wrap">
                            <van-search v-model="business_related_keyword"  placeholder="请输入查询内容"  @clear="handleClickBusinessRelatedSearch" @search="handleClickBusinessRelatedSearch"></van-search>

                            <span class="link-label" @click="handleClickRadioPickerShow('business_related')" v-if="relatedTabActive == 'business' && projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('business_manage'))"><van-icon name="plus" /> 新增商机</span>
                            <span class="link-label" @click="handleClickRadioPickerShow('order_related')" v-if="relatedTabActive == 'order' && projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('business_manage'))"><van-icon name="plus" /> 新增订单</span>
                            <span class="link-label" @click="handleClickRadioPickerShow('work_order_related')" v-if="relatedTabActive == 'work_order' && projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('business_manage'))"><van-icon name="plus" /> 新增工单</span>

                        </div>

                        <div class="related_business_list" v-if="relatedTabActive == 'business'">
                            <ul v-infinite-scroll="onLoadList">
                                <li v-for="(item,key) in businessTableList" :key="key">
                                    <div class="top">
                                        <div class="title link-label ellipsis">
                                            <i class="iconfont icon-shangji1"></i>
                                            <span v-text="item.name ? item.name.value : ''"></span>
                                        </div>
                                        <span v-if="projectDetail.status == 0" class="handle" @click.stop="handleClickBusinessItem(item)">
                                        <i class="iconfont icon-gengduo"></i>
                                    </span>
                                    </div>
                                    <div class="bottom">
                                        <div class="field_item ellipsis">
                                            <span class="field_name">客户：</span>
                                            <span class="field_value" v-text="item.customer_name"></span>
                                        </div>
                                        <div class="field_item ellipsis">
                                            <span class="field_name">负责人：</span>
                                            <span class="field_value" v-if="item.salesperson && item.salesperson.text  && item.salesperson.text.length">
                                             <span class="user_head" @click="handleClickRelateHandle('user_detail',{uid:item.salesperson.text[0].id})">
                                                 <img :src="item.salesperson.text[0].avatar ? item.salesperson.text[0].avatar : defaultImg" alt="" />
                                                 <span v-text="item.salesperson.text[0].name"></span>
                                             </span>
                                        </span>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                        </div>

                        <div class="related_order_list" v-if="relatedTabActive == 'order'">
                            <ul v-infinite-scroll="onLoadList">
                                <li v-for="(item,key) in orderTableList" :key="key">
                                    <div class="top">
                                        <div class="title link-label ellipsis" @click="handleClickRelateHandle('order_detail',item)">
                                            <span v-text="item.order_num"></span>
                                        </div>
                                        <span  class="handle" @click.stop="handleClickOrderItem(item)">
                                        <i class="iconfont icon-gengduo"></i>
                                    </span>
                                    </div>
                                    <div class="bottom">
                                        <div class="field_item ellipsis">
                                            <span class="field_name">客户：</span>
                                            <span class="field_value" v-text="item.customer_name"></span>
                                        </div>
                                        <div class="field_item ellipsis flex_js_wrap">
                                            <div>
                                                <span class="field_name">销售：</span>
                                                <span class="field_value" v-if="item.salesperson && item.salesperson.text  && item.salesperson.text.length">
                                                <span class="user_head" @click="handleClickRelateHandle('user_detail',{uid:item.salesperson.text[0].id})">
                                                     <img :src="item.salesperson.text[0].avatar ? item.salesperson.text[0].avatar : defaultImg" alt="" />
                                                     <span v-text="item.salesperson.text[0].name"></span>
                                                 </span>
                                            </span>
                                            </div>
                                            <div>
                                                <span class="field_name">订单总金额：</span>
                                                <span class="field_value" v-if="item.total_price" v-text="'￥' + item.total_price.value"></span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div class="related_work_order_list" v-if="relatedTabActive == 'work_order'">
                            <ul v-infinite-scroll="onLoadList">
                                <li v-for="(item,key) in workOrderTableList" :key="key">
                                    <div class="top">
                                        <div class="title  ellipsis">
                                            <span class="num_title link-label" v-text="item.workorder_num" @click="handleClickRelateHandle('work_order_detail',item)"></span>
                                            <span class="status_code" :class="'work_order_status' + item.status" v-text="item.status_text"></span>
                                        </div>
                                        <span v-if="projectDetail.status == 0  && (userPermission.includes('all') || userPermission.includes('business_manage'))" class="handle" @click.stop="handleClickWorkOrderItem(item)">
                                        <i class="iconfont icon-gengduo"></i>
                                    </span>
                                    </div>
                                    <div class="bottom">
                                        <div class="field_item ellipsis">
                                            <span class="field_name">工单类型：</span>
                                            <span class="field_value " v-if="item.workorder_type_id" v-text="item.workorder_type_id.text"></span>
                                        </div>
                                        <div class="field_item ellipsis ">
                                            <span class="field_name">发起人：</span>
                                            <span class="field_value" v-if="item.user && item.user.id ">
                                                <span class="user_head" @click="handleClickRelateHandle('user_detail',{uid:item.user.id})">
                                                     <img :src="item.user.avatar ? item.user.avatar : defaultImg" alt="" />
                                                     <span v-text="item.user.name"></span>
                                                 </span>
                                            </span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>


                </div>

                <div class="financial_related_wrap" v-if="activeName == 'financial_related'">
                    <div class="tab_nav_list">
                        <span v-if="userPermission.includes('all') || userPermission.includes('financial_payment')" @click="handleClickRelatedTab('payment')" :class="{'active' : relatedTabActive == 'payment'}">回款 <i>{{projectDetail.repay_num}}</i></span>
                        <span v-if="userPermission.includes('all') || userPermission.includes('financial_profit')"  @click="handleClickRelatedTab('cost')" :class="{'active' : relatedTabActive == 'cost'}">成本 <i>{{projectDetail.cost_num}}</i></span>
                        <span v-if="userPermission.includes('all') || userPermission.includes('financial_payment')" @click="handleClickRelatedTab('invoice')" :class="{'active' : relatedTabActive == 'invoice'}">开票 <i>{{projectDetail.invoice_num}}</i></span>
                    </div>
                    <div class="related_max_height_wrap">

                        <div class="payment_cost_invoice">
                            <ul>
                                <li v-if="relatedTabActive == 'payment'">
                                    <div class="top">回款</div>
                                    <div class="bottom">
                                        <div class="field_name ellipsis">项目订单总金额：{{financialBoardData.board.totalPrice}}</div>
                                        <div class="field_name ellipsis">待回款总金额：{{financialBoardData.board.noRepayPrice }}</div>
                                        <div class="field_name ellipsis">实际回款总金额：{{financialBoardData.board.repayPrice}}</div>
                                        <div class="field_name ellipsis">采购退款金额：{{financialBoardData.board.purchaseRefundPrice}}</div>
                                    </div>
                                </li>
                                <li v-if="relatedTabActive == 'cost'">
                                    <div class="top">成本/利润</div>
                                    <div class="bottom">
                                        <div class="field_name ellipsis">项目总成本：{{financialBoardData.totalCost}}</div>
                                        <div class="field_name ellipsis">项目实际利润：{{financialBoardData.board.profit}}</div>
                                    </div>
                                </li>
                                <li v-if="relatedTabActive == 'invoice'">
                                    <div class="top">开票</div>
                                    <div class="bottom">
                                        <div class="field_name ellipsis">已开票金额：{{financialBoardData.board.invoicePrice}}</div>
                                        <div class="field_name ellipsis">待开票金额：{{financialBoardData.board.noInvoicePrice}}</div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div class="related_search_wrap">
                            <van-search v-model="payment_related_keyword"  placeholder="请输入查询内容"  @clear="handleClickBusinessRelatedSearch" @search="handleClickBusinessRelatedSearch"></van-search>
                            <span class="link-label" @click="handleClickRelateHandle('payment')" v-if="relatedTabActive == 'payment'  && projectDetail.status == 0"><van-icon name="plus" /> 新建回款</span>
                            <span class="link-label" @click="handleClickAddCost" v-if="relatedTabActive == 'cost'  && projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('financial_cost'))"><van-icon name="plus" /> 新建成本</span>
                            <span class="link-label" @click="handleClickRelateHandle('invoice')" v-if="relatedTabActive == 'invoice'  && projectDetail.status == 0"><van-icon name="plus" /> 新建开票</span>
                        </div>

                        <div class="financial_related_payment" v-if="relatedTabActive == 'payment'">
                            <ul v-infinite-scroll="onLoadList">
                                <li v-for="(item,key) in paymentTableList" :key="key">
                                    <div class="top">
                                        <div class="title link-label ellipsis">
                                            <span class="receivable_no" v-text="item.receivable_no" @click="handleClickRelateHandle('payment_detail',item)"></span>
                                            <span :class="'payment_status_name_'+item.status" class="status_name"  v-text="item.status_name"></span>
                                        </div>
                                    </div>
                                    <div class="bottom">
                                        <div class="field_item ellipsis">
                                            <span class="field_name">回款公司：</span>
                                            <span class="field_value" v-text="item.payment_company_name"></span>
                                        </div>
                                        <div class="field_item ellipsis flex_js_wrap">
                                            <div>
                                                <span class="field_name">申请人：</span>
                                                <span class="field_value" v-if="item.uid_info && item.uid_info.id">
                                                <span class="user_head" @click="handleClickRelateHandle('user_detail',{uid:item.uid_info.id})">
                                                     <img :src="item.uid_info.avatar ? item.uid_info.avatar : defaultImg" alt="" />
                                                     <span v-text="item.uid_info.name"></span>
                                                 </span>
                                            </span>
                                            </div>
                                            <div>
                                                <span class="field_name">回款总金额：</span>
                                                <span class="field_value bold_text" v-if="item.payment_amount" v-text="'￥' + item.payment_amount"></span>
                                            </div>
                                        </div>
                                        <div class="field_item ellipsis">
                                            <span class="field_name">回款日期：</span>
                                            <span class="field_value" v-text="item.payment_date"></span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div class="financial_related_payment" v-if="relatedTabActive == 'cost'">
                            <ul>
                                <li v-for="(item,key) in costTableList" :key="key">
                                    <div class="top">
                                        <div class="title ellipsis">
                                            <span v-if="item.type == 'product'"  @click="handleClickRelateHandle('product_cost_detail',item)" class="link-label" v-text="item.cost_name"></span>
                                            <span v-else-if="item.type == 'purchase'"  @click="handleClickRelateHandle('order_purchase_detail',item)" class="link-label" v-text="item.cost_name"></span>
                                            <span v-else-if="item.type == 'payable'"  @click="handleClickRelateHandle('purchase',item)" class="link-label" v-text="item.cost_name"></span>
                                            <span v-else class="ellipsis" v-text="item.cost_name"></span>
                                        </div>
                                        <span class="handle" v-if="item.type == 'custom' && projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('financial_cost'))" @click.stop="handleClickCostItem(item)">
                                            <i class="iconfont icon-gengduo"></i>
                                        </span>
                                    </div>
                                    <div class="bottom">
                                        <div class="field_item ellipsis">
                                            <span class="field_name">成本金额：</span>
                                            <span class="field_value bold_text" v-text="item.price"></span>
                                        </div>
                                        <div class="field_item ellipsis">
                                            <span class="field_name">创建人：</span>
                                            <span class="field_value" v-text="item.name"></span>
<!--                                            <span class="field_value">-->
<!--                                                 <span class="user_head" @click="handleClickRelateHandle('user_detail',{uid:item.uid_info.id})">-->
<!--                                                     <img :src="item.uid_info.avatar ? item.uid_info.avatar : defaultImg" alt="" />-->
<!--                                                     <span v-text="item.uid_info.name"></span>-->
<!--                                                 </span>-->
<!--                                            </span>-->

                                        </div>
                                        <div class="field_item ellipsis">
                                            <span class="field_name">创建时间：</span>
                                            <span class="field_value" v-text="item.created_at"></span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div class="financial_related_payment" v-if="relatedTabActive == 'invoice'">
                            <ul v-infinite-scroll="onLoadList">
                                <li v-for="(item,key) in invoiceTableList" :key="key">
                                    <div class="top">
                                        <div class="title link-label ellipsis">
                                            <span class="receivable_no" v-text="item.invoice_no" @click="handleClickRelateHandle('invoice_detail',item)"></span>
                                            <span :class="'invoice_status_name_'+item.status" class="status_name"  v-text="item.status_name"></span>
                                        </div>
                                    </div>
                                    <div class="bottom">
                                        <div class="field_item ellipsis">
                                            <span class="field_name">开票公司：</span>
                                            <span class="field_value" v-text="item.invoice_company_name"></span>
                                        </div>
                                        <div class="field_item ellipsis flex_js_wrap">
                                            <div>
                                                <span class="field_name">申请人：</span>
                                                <span class="field_value" v-if="item.apply_user_info && item.apply_user_info.id">
                                                <span class="user_head" @click="handleClickRelateHandle('user_detail',{uid:item.apply_user_info.id})">
                                                     <img :src="item.apply_user_info.avatar ? item.apply_user_info.avatar : defaultImg" alt="" />
                                                     <span v-text="item.apply_user_info.name"></span>
                                                 </span>
                                            </span>
                                            </div>
                                            <div>
                                                <span class="field_name">开票金额：</span>
                                                <span class="field_value bold_text" v-if="item.invoice_amount" v-text="'￥' + item.invoice_amount"></span>
                                            </div>
                                        </div>
                                        <div class="field_item ellipsis">
                                            <span class="field_name">开票申请日期：</span>
                                            <span class="field_value" v-text="item.apply_time"></span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>

                <div class="inventory_related_wrap" v-if="activeName == 'inventory_related'">
                    <div class="tab_nav_list" style="padding: 0 64px">
                        <span @click="handleClickRelatedTab('add_out_record')" :class="{'active' : relatedTabActive == 'add_out_record'}">出库 <i>1</i></span>
                        <span @click="handleClickRelatedTab('add_in_record')" :class="{'active' : relatedTabActive == 'add_in_record'}">入库 <i>2</i></span>
                    </div>
                    <div class="related_max_height_wrap">
                        <div class="inventory_related_more">
                            <van-divider v-if="relatedTabActive == 'add_out_record' && outInventoryData.length == 0" dashed>暂无数据</van-divider>
                            <van-divider v-if="relatedTabActive == 'add_in_record' && inInventoryData.length == 0" dashed>暂无数据</van-divider>
                            <van-icon v-if="(relatedTabActive == 'add_out_record' && outInventoryData.length == 0) || (relatedTabActive == 'add_in_record' && inInventoryData.length == 0)"  name="arrow" @click="handleClickInventoryStatistics(relatedTabActive)"/>
                        </div>
                        <div class="inventory_related_statistics">
                            <ul  v-if="relatedTabActive == 'add_out_record'">
                                <li class="flex_js_wrap ellipsis" v-for="item in outInventoryData.slice(0, 3)">
                                    <p class="ellipsis">{{item.name}} × {{item.total_num}}</p>
                                    <p class="ellipsis" v-if="userPermission.includes('all') || userPermission.includes('inventory_total_cost')">总价：{{item.total_cost}}</p>
                                </li>
                            </ul>
                            <ul  v-if="relatedTabActive == 'add_in_record'">
                                <li class="flex_js_wrap ellipsis" v-for="item in inInventoryData.slice(0, 3)">
                                    <p class="ellipsis">{{item.name}} × {{item.total_num}}</p>
                                    <p class="ellipsis" v-if="userPermission.includes('all') || userPermission.includes('inventory_total_cost')">总价：{{item.total_cost}}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="related_search_wrap">
                            <van-search v-model="stock_record_related_keyword"  placeholder="请输入查询内容"  @clear="handleClickBusinessRelatedSearch" @search="handleClickBusinessRelatedSearch"></van-search>
                            <span class="link-label" @click="handleClickRelateHandle('add_out_record')" v-if="relatedTabActive == 'add_out_record' && projectDetail.status == 0"><van-icon name="plus" /> 新建出库</span>
                            <span class="link-label" @click="handleClickRelateHandle('add_in_record')" v-if="relatedTabActive == 'add_in_record' && projectDetail.status == 0"><van-icon name="plus" /> 新建入库</span>
                        </div>

                        <div class="inventory_related_list" v-if="relatedTabActive == 'add_out_record'">
                            <ul v-infinite-scroll="onLoadList">
                                <li v-for="item in outRecordTableList" @click.stop="handleClickRelateHandle('out_record_detail',item)">
                                   <div class="field_item ellipsis flex_js_wrap">
                                       <div class="ellipsis">
                                           <span class="field_name">发起人：</span>
                                           <span class="field_value" v-if="item.approval_user">
                                               <span class="user_head" @click="handleClickRelateHandle('user_detail',{uid:item.approval_user.id})">
                                                    <img :src="item.approval_user.avatar ? item.approval_user.avatar : defaultImg" alt="" />
                                                    <span>{{item.approval_user.name}}</span>
                                                </span>
                                           </span>
                                       </div>
                                       <div class="ellipsis">
                                           <span class="field_name">业务编号：</span>
                                           <span class="field_value link-label" @click.stop="handleClickRelateHandle('stock_related_detail',item)" v-if="item.related_info" v-text="item.related_info.related_num"></span>
                                       </div>
                                   </div>
                                   <div class="field_item ellipsis flex_js_wrap">
                                       <div class="ellipsis">
                                           <span class="field_name">处理人：</span>
                                           <span class="field_value" v-if="item.creator_info">
                                              <span class="user_head" @click.stop="handleClickRelateHandle('user_detail',{uid:item.creator_info.id})">
                                                    <img :src="item.creator_info.avatar ? item.creator_info.avatar : defaultImg" alt="" />
                                                    <span>{{item.creator_info.name}}</span>
                                                </span>
                                           </span>
                                       </div>
                                       <div class="ellipsis">
                                           <span class="field_name">单据日期：</span>
                                           <span class="field_value" >{{item.created_at}}</span>
                                       </div>
                                   </div>
                                </li>
                            </ul>
                        </div>
                        <div class="inventory_related_list" v-if="relatedTabActive == 'add_in_record'">
                            <ul v-infinite-scroll="onLoadList">
                                <li v-for="item in inRecordTableList"  @click.stop="handleClickRelateHandle('in_record_detail',item)">
                                    <div class="field_item ellipsis flex_js_wrap">
                                        <div class="ellipsis">
                                            <span class="field_name">发起人：</span>
                                            <span class="field_value" v-if="item.approval_user">
                                               <span class="user_head" @click.stop="handleClickRelateHandle('user_detail',{uid:item.approval_user.id})">
                                                    <img :src="item.approval_user.avatar ? item.approval_user.avatar : defaultImg" alt="" />
                                                    <span>{{item.approval_user.name}}</span>
                                                </span>
                                           </span>
                                        </div>
                                        <div class="ellipsis">
                                            <span class="field_name">业务编号：</span>
                                            <span class="field_value link-label" @click.stop="handleClickRelateHandle('stock_related_detail',item)" v-if="item.related_info" v-text="item.related_info.related_num"></span>
                                        </div>
                                    </div>
                                    <div class="field_item ellipsis flex_js_wrap">
                                        <div class="ellipsis">
                                            <span class="field_name">处理人：</span>
                                            <span class="field_value" v-if="item.creator_info">
                                              <span class="user_head" @click="handleClickRelateHandle('user_detail',{uid:item.creator_info.id})">
                                                    <img :src="item.creator_info.avatar ? item.creator_info.avatar : defaultImg" alt="" />
                                                    <span>{{item.creator_info.name}}</span>
                                                </span>
                                           </span>
                                        </div>
                                        <div class="ellipsis">
                                            <span class="field_name">单据日期：</span>
                                            <span class="field_value" >{{item.created_at}}</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="approval_related_wrap" v-if="activeName == 'approval_related'">

                    <div class="related_search_wrap">
                        <van-search v-model="approval_related_keyword"  placeholder="请输入查询内容"  @clear="handleClickBusinessRelatedSearch" @search="handleClickBusinessRelatedSearch"></van-search>
                        <span v-if="projectDetail.status == 0" class="link-label" @click="handleClickRadioPickerShow('approval_related')"><van-icon name="plus" /> 新增审批</span>
                    </div>

                    <div class="approval_related_list">
                        <ul>
                            <li v-for="item in approvalTableList">
                                <div class="top">
                                    <div class="title  ellipsis">
                                        <span class="name ellipsis" v-text="(item.approval_detail && item.approval_detail.approve_title) ? item.approval_detail.approve_title.name : ''"></span>
                                        <span class="link-label" @click="handleClickRelateHandle('approval_detail',{approval_id:item.relate_id})">ID:{{item.relate_id}}</span>
                                    </div>
                                    <span v-if="projectDetail.status == 0" class="handle" @click.stop="handleClickApprovalItem(item)">
                                        <i class="iconfont icon-gengduo"></i>
                                    </span>
                                </div>
                                <div class="bottom">
                                    <div class="field_item ellipsis flex_js_wrap">
                                         <span class="user_head" v-if="item.approval_detail && item.approval_detail.user" @click="handleClickRelateHandle('user_detail',{uid:item.approval_detail.user.id})">
                                              <img :src="item.approval_detail.user.avatar ? item.approval_detail.user.avatar : defaultImg" alt="" />
                                              <span>{{item.approval_detail.user.name}}</span>
                                         </span>
                                        <div class="field_name" v-if="item.approval_detail">申请时间：{{item.approval_detail.created_at}}</div>
                                    </div>
                                    <div class="field_item ellipsis flex_js_wrap">
                                        <div class="field_name">关联人</div>
                                        <div class="field_value">
                                            <span class="user_head" v-if="item.user" @click="handleClickRelateHandle('user_detail',{uid:item.user.id})">
                                               <img :src="item.user.avatar ? item.user.avatar : defaultImg" alt="" />
                                               <span>{{item.user.name}}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>




                </div>

                <div class="project_members_wrap" v-if="activeName == 'project_members'">
                    <div class="related_search_wrap">
                        <van-search v-model="project_members_keyword"  placeholder="请输入查询内容"  @clear="handleClickBusinessRelatedSearch" @search="handleClickBusinessRelatedSearch"></van-search>
                        <span v-if="projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('member_operate'))" class="project_upload_button link-label" @click="handleClickRelateHandle('add_member')"><van-icon name="plus" /> 添加成员</span>
                    </div>
                    <div class="project_members_list">
                        <ul v-infinite-scroll="onLoadList">
                            <li v-for="(item,key) in membersTableList" :key="key">
                                <div class="top">
                                    <div class="title  ellipsis">
                                        <span v-text="item.member_role"></span>
                                    </div>
                                    <span class="handle" v-if="projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('member_operate'))" @click.stop="handleClickMembersItem(item)">
                                        <i class="iconfont icon-gengduo"></i>
                                    </span>
                                </div>
                                <div class="bottom">
                                    <div class="field_item ellipsis flex_js_wrap" v-if="item.member_role == '项目负责人'">
                                         <div>
                                            <span class="field_value" v-if="item.members && item.members.length">
                                                <span class="user_head" @click="handleClickRelateHandle('user_detail',{uid:item.members[0].member_user.id})">
                                                     <img :src="item.members[0].member_user.avatar ? item.members[0].member_user.avatar : defaultImg" alt="" />
                                                     <span v-text="item.members[0].member_user.name"></span>
                                                 </span>
                                            </span>
                                        </div>
                                        <div>
                                            <span class="field_name">全部权限</span>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="field_item ellipsis" >
                                            <span class="field_value" v-if="item.members" v-text="item.members.map(map => map.member_user.name).join()"></span>
                                        </div>
                                        <div class="field_item ellipsis">
                                            <span class="field_name">
                                                 <span v-if="item.permission_range.indexOf('all') >-1">全部权限</span>
                                                 <span v-else v-text="item.permission_range_text"></span>
                                            </span>
                                        </div>

                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                </div>

                <div class="project_file_wrap" v-if="activeName == 'project_file'">
                    <div class="related_search_wrap">
                        <van-search v-model="project_file_keyword"  placeholder="请输入查询内容"  @clear="handleClickBusinessRelatedSearch" @search="handleClickBusinessRelatedSearch"></van-search>

                        <span v-if="projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('project_file_operate'))" class="project_upload_button link-label" ><van-icon name="plus" /> 上传文件
                            <input  class="upload_input" type="file"  @change="handleUploadChange($event)">
                        </span>
                    </div>

                    <div class="project_file_list">
                        <ul v-infinite-scroll="onLoadList">
                            <li v-for="(item,key) in fileTableList" :key="key">
                                <div class="top ellipsis">
                                    <span class="user_head" @click="handleClickRelateHandle('user_detail',{uid:item.user.id})">
                                        <img :src="item.user.avatar ? item.user.avatar : defaultImg" alt="" />
                                        <span v-text="item.user.name"></span>
                                    </span>
                                    <span class="time">创建时间：{{item.created_at}}</span>
                                    <span v-if="item.type == 'project_manage' && projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('project_file_operate'))" class="handle_icon_wrap handle_icon_danger_wrap"  @click="handleClickDelFile(item)">
                                        <i class="iconfont icon-shanchu1"></i>
                                    </span>
                                    <span v-if="item.type =='quotation'" class="link-label" @click="handleClickRelateHandle('view_the_quotation',{project_quotation_id:item.file_path, title:item.file_name})">查看详情</span>
                                </div>
                                <div class="bottom">
                                    <div class="file_list">
                                        <ul>
                                            <li >
                                                <p class="ellipsis" v-text="item.file_name"></p>
                                                <div v-if="item.type !='quotation'">
                                                    <span @click="handleClickPreview(item)"><i class="iconfont icon-yanjing"></i></span>
                                                    <span  @click="handleClickDownloadFile(item)">   <i class="iconfont icon-daochu"></i> </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                </div>

            </div>


        </div>
        <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }" z-index="1000" v-if="handleRadioPicker" :show="handleRadioPicker" @click="handleRadioPicker = false" >
            <div class="custome_radio_option_wrap">
                <ul class="radio_option_list">
                    <li class="radio_option_item" v-for="item in handleRadioPickerList[handleRadioType]"  @click="handleClickRadioPicker(item)" v-text="item.text"></li>
                </ul>
                <div class="cancel_btn" @click="handleRadioPicker = false">取消</div>
            </div>
        </van-overlay>

        <!--相关关联的操作-->
        <RelatedHandle ref="relatedHandle" @relatedHandleSuccess="relatedHandleSuccess"/>
        <!--项目详情-->
        <ProjectBaseDetail  v-if="projectBaseDetailPopupShow" :projectBaseDetailPopupShow.sync="projectBaseDetailPopupShow" :projectDetail="projectDetail"/>
        <!--项目进度-->
        <ProjectProgress  v-if="projectProgressPopupShow" :projectProgressPopupShow.sync="projectProgressPopupShow" :projectId="projectId" :projectDetail="projectDetail"/>
        <!--成本-->
        <CostTpl v-if="costPopupShow" :costPopupShow.sync="costPopupShow" :projectId="projectId" :costId="costId" @success="costSuccess"/>
        <!--库存统计-->
        <InventoryStatistics v-if="inventoryStatisticsPopupShow" :inventoryStatisticsPopupShow.sync="inventoryStatisticsPopupShow" :type="relatedTabActive" :userPermission="userPermission" :projectId="projectId"/>
    </div>
</template>

<script>
import {
    ProjectManageDel,
    ProjectManageFinish,
    ProjectManageFinishCancel,
    ProjectManageClose,
    ProjectManageCloseCancel,
    ProjectManageDetail,
    getFormFields,
    projectList,
    ProjectLogList,
    ProjectLogDel,
    ProjectFileList,
    ProjectFileAdd,
    ProjectFileDel,
    ProjectManageMemberList,
    ProjectManageApprovalList,
    orderList,
    workOrderList,
    ProjectManageCostList,
    ProjectManageCostDel,
    orderInvoiceSummary,
    orderRepaymentList,
    ProjectManageFinancialBoard,
    ProjectManageStockCostDetail,
    stockOutList,
    stockInList,
    ProjectManagePermission
} from "@/api";
import {formatFileSize,getFileType,formatToNumber} from "@/utils";
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import RelatedHandle from "./component/related_handle.vue";
import ProjectProgress from "./component/project_progress.vue";
import CostTpl from "./component/cost_tpl"
import InventoryStatistics  from "./component/inventory_statistics"
import ProjectBaseDetail from "./component/project_detail_base"
import * as echarts from "echarts";
import {pagination} from '@/mixins'
import { Dialog ,ImagePreview} from "vant";

export default {
    name: "ProjectDetail",
    components: { ReturnNavBar,RelatedHandle,ProjectProgress,CostTpl,InventoryStatistics,ProjectBaseDetail},
    data() {
        return {
            projectId:0,
            loading:false,
            defaultImg: require('@/assets/images/default.jpg'),
            headOperatePopoverShow: false,
            headOperateActionsList: [
                {value:'business', text: "新增商机", icon: "iconfont icon-shangji1",children:[{value:'add_business', text: "新建商机"},{value:'relate_business', text: "关联商机"}] },
                {value:'order',  text: "新增订单", icon: "iconfont icon-xinzengdingdan",children:[{value:'add_order', text: "新建订单"},{value:'relate_order', text: "关联订单"}] },
                {value:'work_order',text: "新增工单", icon: "iconfont icon-tianjia1",children:[{value:'add_work_order', text: "新建工单"},{value:'relate_work_order', text: "关联工单"}] },
                {value:'add_payment',text: "新建回款", icon: "iconfont icon-tuikuan" },
                {value:'add_cost',text: "新建成本", icon: "iconfont icon-a-yinyongzujian1" },
                {value:'add_invoice',text: "新建开票", icon: "iconfont icon-fapiao1" },
                {value:'record',text: "新建出入库", icon: "iconfont icon-cangku2",children:[{value:'add_out_record', text: "新建出库"},{value:'add_in_record', text: "新建入库"}] },
                {value:'approval',text: "新增审批", icon: "iconfont icon-shenpi_weixuanzhong",children:[{value:'add_approval', text: "发起审批"},{value:'relate_approval', text: "关联审批"}] },
                {value:'add_member',text: "添加成员", icon: "iconfont icon-a-shenling1" },
            ],
            headOperateType: '',
            projectDetail:{},
            activeName:'project_board',
            tabList:[
                {title:'项目看板',value:'project_board'},
                {title:'业务相关',value:'business_related'},
                {title:'财务相关',value:'financial_related'},
                {title:'库存相关',value:'inventory_related'},
                {title:'关联审批',value:'approval_related'},
                {title:'项目成员',value:'project_members'},
                {title:'项目资料',value:'project_file'},
            ],
            logList:[], //记录
            board_financial_tab:'income',
            costMode:'pie',
            myChartBar:null,
            myChartPie:null,
            financialBoardData:{
                board:{
                    noRepayPrice:'0.00',
                    profit:'0.00',
                    purchaseRefundPrice:'0.00',
                    repayPrice:'0.00',
                    totalPrice:'0.00',
                    invoicePrice: "0.00",
                    noInvoicePrice: "0.00"
                },
                repayPricePercentage:0.00,//已回款比例
                cost:[],
                totalCost:'0.00',
            }, //财务看板
            projectProgressPopupShow:false,
            relatedTabActive:'business',
            related_keyword:'', //关联的筛选
            business_related_keyword:'',//商机筛选
            payment_related_keyword :'', //回款筛选
            stock_record_related_keyword:'', //库存记录筛选
            approval_related_keyword:'', //关联审批筛选
            project_members_keyword:'',//项目成员筛选
            project_file_keyword:'', //项目资料筛选
            related_popover_show:false,
            businessTableList:[],//商机列表
            orderTableList:[],//订单列表
            workOrderTableList:[], //工单列表
            paymentTableList:[],//回款列表
            costTableList:[],//成本列表
            invoiceTableList:[],//开票列表
            outInventoryData:[], //数据看板-出库
            inInventoryData:[], //数据看板-入库
            outRecordTableList:[],//出库记录
            inRecordTableList:[],//出库记录
            approvalTableList:[],//审批列表
            membersTableList:[],//成员列表
            fileTableList:[],//附件列表

            handleRadioPicker:false,
            handleRadioType:'',
            handleRadioPickerList:{
                business_related:[
                    {value:'add_business', text: "新建商机"},{value:'relate_business', text: "关联商机"}
                ],
                order_related:[
                    {value:'add_order', text: "新建订单"},{value:'relate_order', text: "关联订单"}
                ],
                work_order_related:[
                    {value:'add_work_order', text: "新建工单"},{value:'relate_work_order', text: "关联工单"}
                ],
                approval_related:[
                    {value:'add_approval', text: "新建审批"},{value:'relate_approval', text: "关联审批"}
                ],
                business_handle:[
                    {value:'business_disassociation',text:'取消关联'},
                    {value:'add_New_quotation',text:'新增报价'},
                ],
                order_handle:[
                    {value:'order_disassociation',text:'取消关联'},
                    {value:'after_sales',text:'售后'},
                ],
                work_order_handle:[
                    {value:'work_order_disassociation',text:'取消关联'},
                ],
                approval_handle:[
                    {value:'approval_disassociation',text:'取消关联'},
                ],
                cost_handle:[
                    {value:'edit_cost',text:'编辑成本'},
                    {value:'del_cost',text:'删除'},
                ],
                members_handle:[
                    {value:'edit_member',text:'编辑'},
                    {value:'del_member',text:'删除'},
                ],
                change_person:[
                   {value:'change_person',text:'更换负责人'},
                ],

            },
            relateActiveInfo:null,
            costId:0,
            costPopupShow:false,
            inventoryStatisticsPopupShow:false,
            projectBaseDetailPopupShow:false,
            userPermission:[],
        };
    },
    mixins: [pagination],
    created() {
        this.projectId = Number(this.$route.query.id)
        this.getProjectManagePermission()
    },
    // 从上一页返回的时候刷新
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.handleClickBusinessRelatedSearch();
            if(!vm.loading){
                vm.getProjectManagePermission();
            }

        });
    },
    methods: {
        // 获取个人权限
        getProjectManagePermission(){
            this.loading = true
            ProjectManagePermission({ project_manage_id:this.projectId }).then((res) => {
                if(res.code == 200){
                    let {data} = res
                    this.userPermission = data
                    // 先重置
                    this.headOperateActionsList = JSON.parse(JSON.stringify(this.$options.data().headOperateActionsList))
                    this.tabList = JSON.parse(JSON.stringify(this.$options.data().tabList))
                    if(!data.includes('all') ){
                        // 右上角操作
                        if(!data.includes('business_manage')){
                            this.headOperateActionsList.splice(0,3)
                        }
                        if(!data.includes('financial_payment')){
                            this.headOperateActionsList.splice(this.headOperateActionsList.findIndex(item=>item.value==='add_payment'),1)
                            this.headOperateActionsList.splice(this.headOperateActionsList.findIndex(item=>item.value==='add_invoice'),1)
                        }
                        if(!data.includes('financial_cost')){
                            this.headOperateActionsList.splice(this.headOperateActionsList.findIndex(item=>item.value==='add_cost'),1)
                        }
                        if(!data.includes('member_operate')){
                            this.headOperateActionsList.splice(this.headOperateActionsList.findIndex(item=>item.value==='add_member'),1)
                        }

                        // tab切换
                        if(!data.includes('business_related_detail')){
                            this.tabList.splice(this.tabList.findIndex(item=>item.value==='business_related'),1)
                        }
                        if(!data.includes('financial_related_detail')){
                            this.tabList.splice(this.tabList.findIndex(item=>item.value==='financial_related'),1)
                        }
                        if(!data.includes('inventory_related_detail')){
                            this.tabList.splice(this.tabList.findIndex(item=>item.value==='inventory_related'),1)
                        }
                        if(!data.includes('member_related_detail')){
                            this.tabList.splice(this.tabList.findIndex(item=>item.value==='project_members'),1)
                        }
                        if(!data.includes('project_file_detail')){
                            this.tabList.splice(this.tabList.findIndex(item=>item.value==='project_file'),1)
                        }
                    }

                    this.getProjectDetail()
                }
            });
        },
        // 获取项目详情
        getProjectDetail(only = false){
            this.loading = true
            ProjectManageDetail({ id:this.projectId }).then((res) => {
                if (res.code == 200) {
                    this.projectDetail = res.data
                    this.projectDetail.business_number = this.projectDetail.relates ? this.projectDetail.relates.filter(item=>item.relate_type==='project').length : 0
                    this.projectDetail.order_number = this.projectDetail.relates ? this.projectDetail.relates.filter(item=>item.relate_type==='order').length : 0
                    this.projectDetail.work_order_number = this.projectDetail.relates ? this.projectDetail.relates.filter(item=>item.relate_type==='workorder').length : 0
                    this.projectDetail.order_list = this.projectDetail.relates ? this.projectDetail.relates.filter(item=>item.relate_type==='order').map((item)=> {
                        return {order_id: item.relate_id, order_num: item.relate_num}
                    }) : []
                    this.projectDetail.business_list = this.projectDetail.relates ? this.projectDetail.relates.filter(item=>item.relate_type==='project').map((item)=> {
                        return {project_id: item.relate_id, project_name: item.relate_detail.name}
                    }) : []
                    this.projectDetail.work_order_list = this.projectDetail.relates ? this.projectDetail.relates.filter(item=>item.relate_type==='workorder').map((item)=> {
                        return {workorder_id: item.relate_id, workorder_num: item.relate_num}
                    }) : []
                    this.projectDetail.approval_list = this.projectDetail.relates ? this.projectDetail.relates.filter(item=>item.relate_type==='approval').map((item)=> {
                        return {approval_id: item.relate_id,}
                    }) : []
                    if(only == false){
                        this.getProjectLogList()
                        this.getProjectManageFinancialBoard()
                    }
                    this.loading = false
                }else{
                    this.loading = false
                }

            });
        },
        // 获取项目进度列表
        getProjectLogList(){
            let postData = {
                id: this.projectId,
            }
            ProjectLogList(postData).then(res => {
                if (res.code === 200) {
                    this.logList  = res.data || []
                }
            })
        },
        // 获取项目看板 - 财务看板
        getProjectManageFinancialBoard(){
            let postData = {
                project_manage_id: this.projectId,
            }
            ProjectManageFinancialBoard(postData).then(res => {
                if (res.code === 200) {
                    let {data} = res
                    this.financialBoardData = data
                    let repayPricePercentage = Number(data.board.repayPrice) / Number(data.board.totalPrice) * 100
                    repayPricePercentage = (isNaN(repayPricePercentage) || repayPricePercentage < 0) ? 0 : repayPricePercentage
                    this.financialBoardData.repayPricePercentage = formatToNumber(repayPricePercentage,2) == Infinity ? 0 : formatToNumber(repayPricePercentage,2)

                    if(this.board_financial_tab == 'cost'){
                        this.handleClickBoardFinancialTab('cost')
                    }
                }
            })
        },
        // 切换tab
        handleClickTab(item){
          this.activeName = item.value
            if(this.activeName == 'business_related'){
                this.relatedTabActive = 'business'
            }else if(this.activeName == 'financial_related'){ //财务相关
                if(this.userPermission.includes('all') || this.userPermission.includes('financial_payment')){
                    this.relatedTabActive = 'payment'
                }else if(this.userPermission.includes('financial_profit')){
                    this.relatedTabActive = 'cost'
                }else{
                    this.relatedTabActive = ''
                }
            }else if(this.activeName == 'inventory_related'){
                this.relatedTabActive = 'add_out_record'
                this.getProjectManageStockCostDetail()
            }else if(this.activeName == 'approval_related'){

            }
            this.handleClickBusinessRelatedSearch()
        },
        // 相关切换
        handleClickRelatedTab(tab){
            this.relatedTabActive = tab
            this.handleClickBusinessRelatedSearch()
        },
        // 新建成本
        handleClickAddCost(){
            this.costId = 0
            this.costPopupShow = true
        },
        // 编辑成本
        handleClickEditCost(item){
            this.costId = Number(item.id)
            this.costPopupShow = true
        },
        // 成本新增编辑完毕回调
        costSuccess(){
            if(this.activeName == 'project_board'){
                this.getProjectManageFinancialBoard()
            }else{
                this.getProjectManageCostList()
            }
        },
        // 删除成本
        handleClickDelCost(item){
            console.log(item);
            Dialog.confirm({
                title: "删除成本",
                message: "确定要删除吗？删除后该成本金额将清空",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            })
            .then(() => {
                ProjectManageCostDel({id:item.id}).then(res => {
                    if (res.code === 200) {
                        this.$toast(res.message)
                        if(this.activeName == 'project_board'){
                            this.getProjectManageFinancialBoard()
                        }else{
                            this.getProjectManageCostList()
                        }
                    }
                })
            })
            .catch(() => { });
        },
        // 切换收入和成本
        handleClickBoardFinancialTab(type){
            this.board_financial_tab = type
            if(this.myChartBar) this.myChartBar.dispose()
            if(this.myChartPie) this.myChartPie.dispose()
            if(type == 'cost') {
                this.$nextTick(() => {
                    if (this.costMode == 'pie') {
                        this.getEchartsPie('container1', this.financialBoardData.cost.filter(item=>item.cost >0))
                    } else {
                        this.getEchartsBar('container2', this.financialBoardData.cost.filter(item=>item.cost >0))
                    }
                })
            }
        },
        // 项目成本切换展示
        handleClickCostCharts(mode){
            this.costMode = mode
            this.$nextTick(() => {
                if(mode == 'pie'){
                    if(this.myChartBar) this.myChartBar.dispose()
                    this.getEchartsPie('container1', this.financialBoardData.cost.filter(item=>item.cost >0) )
                }else{
                    if(this.myChartPie) this.myChartPie.dispose()
                    this.getEchartsBar('container2',  this.financialBoardData.cost.filter(item=>item.cost >0))
                }
            })
        },
        generateColors(count) {
            const colors = [];
            for (let i = 0; i < count; i++) {
                const hue = (i * 360 / count) % 360; // 色相均匀分布
                const saturation = 50; // 饱和度降低到 50%
                const lightness = 60; // 亮度调高到 60%
                colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
            }
            return colors;
        },
        // 获取饼图
        getEchartsPie(id, data) {
            let pieData = data.map((item) => {
                return {
                    value: item.cost,
                    name: item.cost_name,
                    rate: item.rate,
                    id:item.id
                };
            });
            let that = this;
            var chartDom = document.getElementById(id);
            this.myChartPie = echarts.init(chartDom);
            var option;
            option = {
                color: this.generateColors(pieData.length),
                title: {},
                grid: {
                    left: '0px',
                    right: '0%',
                    bottom: '0px',
                    containLabel: true
                },
                tooltip: {
                    trigger: 'item',
                    enterable: true,
                    zIndex: 1000, // 提高 tooltip 的层级
                    backgroundColor: "#fffffff",
                    padding: 12,
                    position: function (point, params, dom, rect, size) {
                        return [point[0], point[1]];
                    },
                    formatter: function (params) {
                        let handleHml = `<div class="custom_chart_tooltip">
                                <div class="tooltip_title  flex_js_wrap">
                                    <p class="ellipsis">${params.name}</p>
                                    <div class="handle_wrap">
                                     <span class="handle_icon_wrap tooltip_btn" data-type="edit">
                                          <i class="iconfont icon-bianji tooltip_btn" data-type="edit" data-id="${params.data.id}"></i>
                                      </span>
                                      <span class="handle_icon_wrap handle_icon_danger_wrap tooltip_btn" data-type="del">
                                          <i class="iconfont icon-shanchu1 tooltip_btn" data-type="del" data-id="${params.data.id}"></i>
                                      </span>
                                    </div>
                                </div>
                                <div class="tooltip_content flex_js_wrap"><span>${params.marker} ${params.value}</span> <span>${params.percent}%</span></div>
                        </div>`
                        let html = `<div class="custom_chart_tooltip">
                                <div class="tooltip_title flex_js_wrap">
                                    <p class="ellipsis">${params.name}</p>
                                </div>
                                <div class="tooltip_content flex_js_wrap"><span>${params.marker} ${params.value}</span> <span>${params.percent}%</span></div>
                        </div>`
                        return params.data.id ? handleHml : html
                    }
                },
                series: [
                    {

                        type: 'pie',
                        label: {
                            formatter: function (params) {
                                return `{marker|●} ${params.name}\n    ${params.value}`;
                            },
                            rich: {
                                marker: {
                                    fontSize: 14,
                                }
                            },
                            position: 'outside'
                        },
                        labelLine: {
                            length: 20,

                        },
                        radius: '50%',
                        data: pieData,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    },
                    {
                        type: 'pie',
                        radius: '50%',
                        label: {
                            show: true,
                            position: 'inside',
                            formatter: function (params) {
                                // 根据条件决定是否显示
                                return params.percent > 9 ? `${params.percent}%` : '';
                            },
                            color: '#fff'
                        },
                        data: pieData
                    }
                ]
            };
            option && this.myChartPie.setOption(option);
            // this.myChartPie.off('click');
            this.myChartPie.getDom().addEventListener('click', that.handleChartClick);
            // this.myChartPie.getDom().addEventListener('click', function (e) {
            //     if (e.target && e.target.classList.contains('tooltip_btn')) {
            //         const type = e.target.getAttribute('data-type');
            //         const id = e.target.getAttribute('data-id');
            //         // 处理按钮点击事件
            //
            //         if(type == 'edit'){
            //             that.handleClickEditCost({id:id})
            //         }else{
            //             that.handleClickDelCost({id:id})
            //         }
            //         const tooltipElement = document.querySelector(`.custom_chart_tooltip`);
            //         if (tooltipElement) {
            //             tooltipElement.style.display = 'none';
            //         }
            //
            //     }
            // });
        },
        handleChartClick(e){
            let that = this
            if(that.projectDetail.status != 0){
                return  this.$toast(`项目已${that.projectDetail.status == 1 ? '完结' : '关闭'}，无法操作`)
            }
            if(!that.userPermission.includes('all') && !that.userPermission.includes('financial_cost')){
                return  this.$toast(`没有操作权限，无法操作`)
            }
            if (e.target && e.target.classList.contains('tooltip_btn')) {
                const type = e.target.getAttribute('data-type');
                const id = e.target.getAttribute('data-id');
                // 处理按钮点击事件
                if(type == 'edit'){
                    that.handleClickEditCost({id:id})
                }else{
                    that.handleClickDelCost({id:id})
                }
                const tooltipElement = document.querySelector(`.custom_chart_tooltip`);
                if (tooltipElement) {
                    tooltipElement.style.display = 'none';
                }

            }
        },
        // 获取柱状图
        getEchartsBar(id, data){
            let barData = data.map((item) => {
                return {
                    value: item.cost,
                    name: item.cost_name,
                    rate: item.rate,
                    id:item.id
                };
            });
            var that = this
            var chartDom = document.getElementById(id);
            this.myChartBar = echarts.init(chartDom);
            var option;
            option = {
                color:['#2990FF'],
                grid: {
                    left: '30px',
                    right: '0%',
                    bottom: '10px',
                    containLabel: true
                },
                tooltip: {
                    trigger: 'item',
                    enterable: true,
                    zIndex: 1000, // 提高 tooltip 的层级
                    backgroundColor: "#fffffff",
                    padding: 12,
                    position: function (point, params, dom, rect, size) {
                        let x = params.dataIndex > 2 ? point[0]-size.contentSize[0] : point[0]
                        return [ x, point[1]];
                    },
                    formatter: function (params) {
                        let handleHml = `<div class="custom_chart_tooltip">
                                <div class="tooltip_title flex_js_wrap">
                                    <p class="ellipsis">${params.name}</p>
                                    <div class="handle_wrap">
                                     <span class="handle_icon_wrap tooltip_btn" data-type="edit">
                                          <i class="iconfont icon-bianji tooltip_btn" data-type="edit" data-id="${params.data.id}"></i>
                                      </span>
                                      <span class="handle_icon_wrap handle_icon_danger_wrap tooltip_btn" data-type="del" >
                                          <i class="iconfont icon-shanchu1 tooltip_btn" data-type="del" data-id="${params.data.id}"></i>
                                      </span>
                                    </div>
                                </div>
                                <div class="tooltip_content flex_js_wrap"><span>${params.marker} ${params.value}</span> <span>${params.data.rate}%</span></div>
                        </div>`
                        let html = `<div class="custom_chart_tooltip">
                                <div class="tooltip_title flex_js_wrap">
                                    <p class="ellipsis">${params.name}</p>
                                </div>
                                <div class="tooltip_content flex_js_wrap"><span>${params.marker} ${params.value}</span> <span>${params.data.rate}%</span></div>
                        </div>`
                        return params.data.id ? handleHml : html
                    }
                },
                xAxis: {
                    type: 'category',
                    data: barData.map(item => { return item.name})
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: barData,
                        type: 'bar'
                    }
                ]
            };

            option && this.myChartBar.setOption(option);
            this.myChartBar.getDom().addEventListener('click', that.handleChartClick);
            // this.myChartBar.off('click');
            // this.myChartBar.getDom().addEventListener('click', function (e) {
            //     if (e.target && e.target.classList.contains('tooltip_btn1')) {
            //         const type = e.target.getAttribute('data-type');
            //         const id = e.target.getAttribute('data-id');
            //         // 处理按钮点击事件
            //
            //         if(type == 'edit'){
            //             that.handleClickEditCost({id:id})
            //         }else{
            //             that.handleClickDelCost({id:id})
            //         }
            //         const tooltipElement = document.querySelector(`.custom_chart_tooltip`);
            //         if (tooltipElement) {
            //             tooltipElement.style.display = 'none';
            //         }
            //
            //     }
            // });

        },
        // 筛选相关
        handleClickBusinessRelatedSearch(){
            this.pagination.pageNum = 1;
            this.businessTableList = [] //商机列表
            this.orderTableList = [] //订单列表
            this.workOrderTableList = [] //工单列表
            this.paymentTableList = []//回款列表
            this.costTableList = []//成本列表
            this.invoiceTableList = []//开票列表
            this.outRecordTableList = []//出库记录
            this.inRecordTableList = []//出库记录
            this.approvalTableList = []//审批列表
            this.membersTableList = []//成员列表
            this.fileTableList = []//附件列表
            this.getDataList()
        },
        getDataList(){
            if(this.activeName == 'business_related'){
                if(this.relatedTabActive == 'business'){
                    this.getBusinessTableList()
                }else if(this.relatedTabActive == 'order'){
                    this.getRelatedOrder()
                }else if(this.relatedTabActive == 'work_order'){
                    this.getRelatedWorkOrder()
                }
            }else if(this.activeName == 'financial_related'){
                if(this.relatedTabActive == 'payment'){
                    this.getOrderRepaymentList()
                }else if(this.relatedTabActive == 'cost'){
                    this.getProjectManageCostList()
                }else if(this.relatedTabActive == 'invoice'){
                    this.getOrderInvoiceSummary()
                }
            }else if(this.activeName == 'inventory_related'){
                if(this.relatedTabActive == 'add_out_record'){
                    this.getStockOutList()
                }else if(this.relatedTabActive == 'add_in_record'){
                    this.getStockInList()
                }
            }else if(this.activeName == 'approval_related'){
                this.getProjectManageApprovalList()
            }else if(this.activeName == 'project_members'){
                this.getProjectManageMemberList()
            }else if(this.activeName == 'project_file'){
                this.getProjectFileList()
            }
        },
        // 加载更多
        onLoadList() {
            let length = (this.activeName == 'business_related' && this.relatedTabActive == 'business') ? this.businessTableList.length :
                    (this.activeName == 'business_related' && this.relatedTabActive == 'order') ? this.orderTableList.length :
                    (this.activeName == 'business_related' && this.relatedTabActive == 'work_order') ? this.workOrderTableList.length :
                    (this.activeName == 'financial_related' && this.relatedTabActive == 'payment') ? this.paymentTableList.length :
                    (this.activeName == 'financial_related' && this.relatedTabActive == 'cost') ? this.costTableList.length :
                    (this.activeName == 'financial_related' && this.relatedTabActive == 'invoice') ? this.invoiceTableList.length :
                    (this.activeName == 'inventory_related' && this.relatedTabActive == 'add_out_record') ? this.outRecordTableList.length :
                    (this.activeName == 'inventory_related' && this.relatedTabActive == 'add_in_record') ? this.inRecordTableList.length :
                    this.activeName == 'approval_related' ? this.approvalTableList.length :
                    this.activeName == 'project_members' ? this.membersTableList.length :
                    this.activeName == 'project_file' ? this.fileTableList.length :0
            if(this.pagination.total == length){
                return false
            }
            if(this.loading == false){
                this.getDataList();
            }
        },
        //获取关联的商机列表
        getBusinessTableList() {
            this.loading = true
            projectList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.business_related_keyword,
                project_manage_id:this.projectId
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.pagination.total = total
                    this.businessTableList =  this.businessTableList.concat(data)
                    this.pagination.pageNum++;
                }
                this.loading = false
            })
        },
        // 获取关联的订单
        getRelatedOrder(){
            this.loading = true
            orderList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.business_related_keyword,
                project_manage_id:this.projectId
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.pagination.total = total
                    this.orderTableList =  this.orderTableList.concat(data)
                    this.pagination.pageNum++;
                }
                this.loading = false;
            })
        },
        // 获取关联的工单
        getRelatedWorkOrder(){
            this.loading = true
            workOrderList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.business_related_keyword,
                project_manage_id:this.projectId
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.pagination.total = total
                    this.workOrderTableList =  this.workOrderTableList.concat(data)
                    this.pagination.pageNum++;
                }
                this.loading = false;
            })
        },
        // 获取回款列表
        getOrderRepaymentList(){
            if(this.projectDetail.order_list.length == 0){return false}
            this.loading = true
            orderRepaymentList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.payment_related_keyword,
                order_no_arr:this.projectDetail.order_list.map(item => item.order_num),
                status:[2]
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.pagination.total = total
                    this.paymentTableList =  this.paymentTableList.concat(data)
                    this.pagination.pageNum++;
                }
                this.loading = false;
            })
        },
        // 获取项目成本
        getProjectManageCostList(){
            let postData = {
                project_manage_id: this.projectId,
            }
            this.loading = true
            ProjectManageCostList(postData).then(res => {
                if (res.code === 200) {
                    let {data} = res
                    data.forEach((item)=>{
                        if(item.type != 'custom'){
                            this.$set(item,'cost_name',item.cost_type)
                        }
                    })
                    this.costTableList = data || []
                }
                this.loading = false
            })
        },
        // 获取开票列表
        getOrderInvoiceSummary(){
            if(this.projectDetail.order_list.length == 0){return false}
            this.loading = true
            orderInvoiceSummary({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.payment_related_keyword,
                order_no_arr:this.projectDetail.order_list.map(item => item.order_num),
                status:[2]
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.pagination.total = total
                    this.invoiceTableList =  this.invoiceTableList.concat(data)
                    this.pagination.pageNum++;
                }
                this.loading = false;
            })
        },
        // 获取关联库存的 - 数据看板
        getProjectManageStockCostDetail(){
            let postData = {
                project_manage_id:this.projectId,
                order_ids:this.projectDetail.order_list.map(item => item.order_id)
            }
            ProjectManageStockCostDetail(postData).then(res => {
                if (res.code === 200) {
                    this.outInventoryData = res.data.out //数据看板-出库
                    this.inInventoryData = res.data.in //数据看板-入库
                }
            })
        },
        // 获取出库记录
        getStockOutList(){
            this.loading = true
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.stock_record_related_keyword,
                project_manage_id:this.projectId,
                order_ids:this.projectDetail.order_list.map(item => item.order_id)
            }
            stockOutList(postData).then(res => {
                if (res.code === 200) {
                    const {list, total} = res.data
                    this.pagination.total = total
                    this.outRecordTableList =  this.outRecordTableList.concat(list)
                    this.pagination.pageNum++;
                }
                this.loading = false;
            })
        },
        // 获取入库记录
        getStockInList(){
            this.loading = true
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.stock_record_related_keyword,
                project_manage_id:this.projectId,
                order_ids:this.projectDetail.order_list.map(item => item.order_id)
            }
            stockInList(postData).then(res => {
                if (res.code === 200) {
                    const {list, total} = res.data
                    this.pagination.total = total
                    this.inRecordTableList =  this.inRecordTableList.concat(list)
                    this.pagination.pageNum++;
                }
                this.loading = false;
            })
        },
        // 获取关联的审批
        getProjectManageApprovalList(){
            this.loading = true
            let postData = {
                project_manage_id:this.projectId,
                page: this.pagination.pageNum,
                size: this.pagination.pageSize,
                keyword: this.approval_related_keyword
            }
            ProjectManageApprovalList(postData).then((res) => {
                if (res.code == 200) {
                    let {data,total} = res.data
                    this.approvalTableList = data
                    this.pagination.total = total
                }
                this.loading = false
            })
        },
        // 获取项目成员
        getProjectManageMemberList(){
            this.loading = true
            let postData = {
                project_manage_id:this.projectId,
                page: this.pagination.pageNum,
                size: this.pagination.pageSize,
                keyword: this.project_members_keyword
            }
            ProjectManageMemberList(postData).then((res) => {
                if (res.code == 200) {
                    let {data,total} = res.data
                    data.forEach(item => {
                        item.permission_range_text = this.getPermissionDescriptions(item.permission_range)
                    })
                    this.pagination.total = total
                    this.membersTableList =  this.membersTableList.concat(data)
                    this.pagination.pageNum++;
                }
                this.loading = false
            })
        },
        // 成员权限
        getPermissionDescriptions(permissionsArray) {
            // 权限映射表
            const permissionMap = {
                business_related_detail: '项目详情-业务相关-查看权限',
                business_manage: '项目详情-业务相关-管理权限（可新增或关联商机、订单、工单）',
                financial_related_detail: '项目详情-财务相关-查看权限',
                financial_payment: '项目详情-财务相关-可查看项目回款/开票数据',
                financial_profit: '项目详情-财务相关-可查看项目实际利润/项目成本数据',
                financial_cost: '项目详情-财务相关-可新增/编辑/删除项目成本',
                inventory_related_detail: '项目详情-库存相关-查看权限',
                inventory_total_cost: '项目详情-库存相关-可查看产品成本总价',
                member_related_detail: '项目详情-项目成员-查看权限',
                member_operate: '项目详情-项目成员-添加成员/操作权限',
                project_file_detail: '项目详情-项目资料-查看权限',
                project_file_operate: '项目详情-项目资料-上传/操作权限'
            };

            return permissionsArray
                    .filter(perm => perm in permissionMap)
                    .map(perm => permissionMap[perm])
                    .join(', ');
        },
        // 获取项目资料
        getProjectFileList(){
            this.pagination.total = 0
            this.loading = true
            ProjectFileList({ project_manage_id:this.projectId, keyword: this.project_file_keyword }).then((res) => {
                if (res.code == 200) {
                    this.fileTableList = res.data
                }
                this.loading = false
            })
        },

        // 附件上传
        handleUploadChange(event) {
            const files = event.target.files
            const that = this;
            let file_list = []
            Array.from(files).forEach(file => {
                uploadImg(file, 50).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        file_list.push(res)
                        event.target.value = ''
                    }
                    this.setProjectFileAdd(file_list)
                    event.target.value = ''
                }).catch(error => {
                    event.target.value = ''
                })
            })
        },
        // 上传资料
        setProjectFileAdd(file_list){
            ProjectFileAdd({ files:file_list, project_manage_id:this.projectId }).then((res) => {
                if (res.code == 200) {
                    this.$toast('上传成功')
                    if(this.activeName == 'project_file'){
                        this.getProjectFileList()
                    }
                }
            });
        },
        // 预览
        handleClickPreview(file) {
            let file_type = getFileType(file.file_name)
            if (file_type.includes('image')) {
                ImagePreview({
                    images: [file.file_path],
                    startPosition: 0,
                });
            } else {
                if (file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$toast('当前文件格式不支持预览，请下载后查看')
                }
            }
        },
        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
        // 删除附件
        handleClickDelFile(item){
            Dialog.confirm({
                title: "确定要删除该文件吗？",
                message: "删除后不可恢复，请谨慎操作！",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            })
            .then(() => {
                ProjectFileDel({ id:item.id }).then((res) => {
                    if (res.code == 200) {
                        this.$toast('删除成功')
                        this.getProjectFileList()
                    }
                });
            })
            .catch(() => { });
        },

        // 右上角的加号功能操作
        handleClickHeadOperate(item) {
            this.headOperateType = item.value
            if(!item.children || item.children.length == 0){
                this.handleClickRelateHandle(item.value)
                this.headOperatePopoverShow = false
            }
        },
        handleClickTost(title){
          this.$toast(title)
        },

        // 库存相关-更多
        handleClickInventoryStatistics(type){
            this.inventoryStatisticsPopupShow = true
        },
        // 商机的操作
        handleClickBusinessItem(item){
            this.handleRadioType = 'business_handle'
            if((!this.userPermission.includes('all') && !this.userPermission.includes('business_manage')) || this.projectDetail.status != 0){
                this.handleRadioPickerList[this.handleRadioType] = [
                    {value:'add_New_quotation',text:'新增报价'},
                ]
            }
            this.relateActiveInfo = item
            this.handleRadioPicker = true
        },
        // 订单的操作
        handleClickOrderItem(item){
            this.handleRadioType = 'order_handle'
            this.relateActiveInfo = item
            this.handleRadioPickerList = JSON.parse(JSON.stringify(this.$options.data().handleRadioPickerList))
            if((!this.userPermission.includes('all') && !this.userPermission.includes('business_manage')) || this.projectDetail.status != 0){
                if(item.order_status == 1){
                    this.handleRadioPickerList[this.handleRadioType] = [
                        {value:'after_sales',text:'售后'},
                    ]
                }else{
                  return  this.$toast('没有操作权限，无法操作')
                }
            }
            this.handleRadioPicker = true
        },
        // 工单的操作
        handleClickWorkOrderItem(item){
            this.handleRadioType = 'work_order_handle'
            this.relateActiveInfo = item
            this.handleRadioPicker = true
        },
        // 成本的操作
        handleClickCostItem(item){
            this.handleRadioType = 'cost_handle'
            this.relateActiveInfo = item
            this.handleRadioPicker = true
        },
        // 审批的操作
        handleClickApprovalItem(item){
            this.handleRadioType = 'approval_handle'
            this.relateActiveInfo = item
            this.handleRadioPicker = true
        },
        // 项目成员的操作
        handleClickMembersItem(item){
            if(item.member_role == '项目负责人'){
                this.handleRadioType = 'change_person'
            }else{
                this.handleRadioType = 'members_handle'
            }
            this.relateActiveInfo = item
            this.handleRadioPicker = true
        },
        // 弹出操作
        handleClickRadioPickerShow(type){
            this.handleRadioType = type
            this.handleRadioPicker = true
        },
        // 底部弹出的操作
        handleClickRadioPicker(item){
            if(item.value == 'edit_cost'){
                this.handleClickEditCost(this.relateActiveInfo)
            }else if(item.value == 'del_cost'){
                this.handleClickDelCost(this.relateActiveInfo)
            }else{
                this.handleClickRelateHandle(item.value,this.relateActiveInfo)
            }

        },
        // 关联的功能操作
        handleClickRelateHandle(type,data){
            this.$refs.relatedHandle.projectId = this.projectId
            this.$refs.relatedHandle.projectDetail = this.projectDetail
            this.$refs.relatedHandle.handleClickRelateHandle(type,data)
        },
        // 关联的操作回调
        relatedHandleSuccess(data){
            if(data.type == 'change_person'){

            }
            this.handleClickBusinessRelatedSearch()
            this.getProjectDetail(true)
            this.relateActiveInfo = null
        },
        // 日期对比
        updatedDate(date,logTime){
            let time = logTime.split(' ')[0]
            if(date != time){
                return `（${time}）`
            }else{
                return ''
            }
        },
        // 日志映射
        getLogDescriptions(log){
            let data = null
            switch (log.type) {
                case "project_add":
                    data = {
                        title:'新建商机：',
                        handle_type:'business_detail',
                        relate_num:log.content ? log.content.project_name :'',
                        content_text:'',
                        info:{project_id:log.relate_id, name:log?.content?.project_name}
                    }
                    break;  //新增商机
                case "project_relate":
                    data = {
                        title:'关联商机：',
                        handle_type:'business_detail',
                        relate_num:log.content ? log.content.project_name :'',
                        content_text:'',
                        info:{project_id:log.relate_id, name:log?.content?.project_name}
                    }
                    break; //关联商机
                case "project_push":
                    data = {
                        title:'商机：',
                        handle_type:'business_detail',
                        relate_num:log.content ? log.content.project_name :'',
                        content_text:`已推进至“${log.content?.project_stage_name}”阶段`,
                        info:{project_id:log.relate_id, name:log?.content?.project_name}
                    }
                    break; //商机推进
                case "project_add_quotation":
                    data = {
                        title:'商机：',
                        handle_type:'business_detail',
                        relate_num:log.content ? log.content.project_name :'',
                        content_text:`新增报价`,
                        info:{project_id:log.relate_id, name:log?.content?.project_name},
                        derivative_num:log.content?.project_quotation_num,  //衍生编号
                        derivative_handle_type:'view_the_quotation', //衍生操作type
                        derivative:{  //衍生信息
                            project_quotation_id:log.content?.project_quotation_id,
                            title:log.content?.project_quotation_num,
                        }
                    }
                    break; //商机新增报价

                case "order_add":
                    data = {
                        title:'新建订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:'',
                        info:{order_id:log.relate_id, order_no:log.relate_num}
                    }
                    break; //新增订单
                case "order_relate":
                    data = {
                        title:'关联订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:'',
                        info:{order_id:log.relate_id, order_no:log.relate_num}
                    }
                    break; //关联订单
                case "order_edit":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-订单编辑`,
                        info:{order_id:log.relate_id, order_no:log.relate_num}
                    }
                    break;//订单编辑
                case "order_stock_edit_out":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-订单编辑-出库`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.out_num,  //衍生编号
                        derivative_handle_type:'out_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            out_num:log.content?.out_num,
                            id:log.content?.out_id,
                        }
                    }
                    break;//订单编辑


                case "order_rent_to_sale":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-租借转销售`,
                        info:{order_id:log.relate_id, order_no:log.relate_num}
                    }
                    break;//售后-租借转销售
                case "order_purchase":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`新增代采，代采编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.purchase_num,  //衍生编号
                        derivative_handle_type:'order_purchase_detail', //衍生操作type
                        derivative:{  //衍生信息
                            purchase_num:log.content?.purchase_num,
                            id:log.content?.purchase_id,
                        }
                    }
                    break;//订单代采
                case "order_invoice":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`新建开票${log.content?.invoice_price}，开票编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.invoice_num,  //衍生编号
                        derivative_handle_type:'invoice_detail', //衍生操作type
                        derivative:{  //衍生信息
                            invoice_no:log.content?.invoice_num,
                        }
                    }
                    break;//订单发起开票
                case "order_repay":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`新建回款${log.content?.repay_price}，回款编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.repay_num,  //衍生编号
                        derivative_handle_type:'payment_detail', //衍生操作type
                        derivative:{  //衍生信息
                            receivable_no:log.content?.repay_num,
                        }
                    }
                    break; //订单发起回款
                case "order_return":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-归还`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                    }
                    break;//订单归还
                case "order_stock_out":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`已出库，出库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.out_num,  //衍生编号
                        derivative_handle_type:'out_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            out_num:log.content?.out_num,
                            id:log.content?.out_id,
                        }
                    }
                    break;//订单出库
                case "order_stock_returned_in":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`售后退货已入库，入库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.in_num,  //衍生编号
                        derivative_handle_type:'in_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            in_num:log.content?.in_num,
                            id:log.content?.in_id,
                        }
                    }
                    break;//订单退货入库
                case "order_stock_return_in":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`订单归还已入库，入库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.in_num,  //衍生编号
                        derivative_handle_type:'in_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            in_num:log.content?.in_num,
                            id:log.content?.in_id,
                        }
                    }
                    break;//订单归还入库
                case "order_stock_replace_in":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`订单损坏换新已入库，入库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.in_num,  //衍生编号
                        derivative_handle_type:'in_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            in_num:log.content?.in_num,
                            id:log.content?.in_id,
                        }
                    }
                    break; //订单损坏换新入库
                case "order_stock_replace_out":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`订单损坏换新已出库，出库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.out_num,  //衍生编号
                        derivative_handle_type:'out_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            out_num:log.content?.out_num,
                            id:log.content?.out_id,
                        }
                    }
                    break; //订单损坏换新出库
                case "order_return_goods":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-退货`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        // derivative_num:log.content?.out_num,  //衍生编号
                        // derivative_handle_type:'out_record_detail', //衍生操作type
                        // derivative:{  //衍生信息
                        //     out_num:log.content?.out_num,
                        //     id:log.content?.out_id,
                        // }
                    }
                    break;//订单退货

                case "order_renew":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-续租`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                    }
                    break; //订单续租
                case "order_replace":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-损坏换新`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                    }
                    break;  //订单损坏换新
                case "order_refund":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-退款`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                    }
                    break;  //订单退款
                case "stock_out":
                    data = {
                        title:`普通出库：出库编号`,
                        handle_type:'out_record_detail',
                        relate_num:`${log.relate_num}`,
                        content_text:'',
                        info:{id:log.relate_id}
                    }
                    break; //普通出库
                case "stock_in":
                    data = {
                        title:`普通人库：入库编号`,
                        handle_type:'in_record_detail',
                        relate_num:`${log.relate_num}`,
                        content_text:'',
                        info:{id:log.relate_id}
                    }
                    break; //普通入库

                case "finance_bad_debt":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`坏账金额${log.content?.bad_price}`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:'详情',  //衍生编号
                        derivative_handle_type:'finance_bad_debt_detail', //衍生操作type
                        derivative:{  //衍生信息
                            related_num:log.relate_num,
                        }
                    }
                    break;//订单坏账
                case "finance_repay_confirm":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`回款${log.content?.repay_price}已确认，回款编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.repay_num,  //衍生编号
                        derivative_handle_type:'payment_detail', //衍生操作type
                        derivative:{  //衍生信息
                            receivable_no:log.content?.repay_num,
                        }
                    }
                    break; //财务回款确认
                case "finance_repay_void":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`回款${log.content?.void_price}已作废，回款编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.void_num,  //衍生编号
                        derivative_handle_type:'payment_detail', //衍生操作type
                        derivative:{  //衍生信息
                            receivable_no:log.content?.void_num,
                        }
                    }
                    break; //回款作废
                case "finance_order_invoice":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`开票${log.content?.invoice_price}已确认，开票编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.invoice_num,  //衍生编号
                        derivative_handle_type:'invoice_detail', //衍生操作type
                        derivative:{  //衍生信息
                            invoice_no:log.content?.invoice_num,
                        }
                    }
                    break; //财务确认开票
                case "finance_order_refund":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`退款${log.content?.refund_price}已确认，应付编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.payable_no,  //衍生编号
                        derivative_handle_type:'payable_detail', //衍生操作type
                        derivative:{  //衍生信息
                            id:log.content?.payable_no,
                        }

                    }
                    break;  //财务确认订单退款
                    //'finance_purchase_refund':'采购退款待定',
                    //'finance_purchase_payment':'采购付款待定',

                case "workorder_add":
                    data = {
                        title:'新建工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:'',
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //新建工单
                case "workorder_relate":
                    data = {
                        title:'关联工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:'',
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //关联工单

                case "workorder_feedback_start":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`${log.content.processing_name}已开始实施`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单开始
                case "workorder_depart":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`${log.content.processing_name}已出发`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单实施人出发
                case "workorder_feedback_end":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`${log.content.processing_name}已实施完成`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单实施人结束
                case "workorder_close":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`已关闭`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单关闭
                case "workorder_finish":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`已结单`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单结单
                case "workorder_evaluate":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`已评价`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单评价


                case "approval_relate":
                    data = {
                        title:`${log.user?.name}关联${log.content?.approval_set_name}，审批编号`,
                        handle_type:'approval_detail',
                        relate_num:`ID：${log.relate_id}`,
                        content_text:'',
                        info:{approval_id:log.relate_id}
                    }
                    break; //关联审批
                case "approval_add":
                    data = {
                        title:`${log.user?.name}发起${log.content?.approval_set_name}，审批编号`,
                        handle_type:'approval_detail',
                        relate_num:`ID：${log.relate_id}`,
                        content_text:'',
                        info:{approval_id:log.relate_id}
                    }
                    break; //新建审批

                default:
                    data = {
                        title:`${log.user?.name}`,
                        handle_type:'',
                        relate_num:`${log.relate_num}`,
                        content_text:'',
                        info:{relate_id:log.relate_id}
                    }
                    break;
            }
            return data
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/m_style/project_management.scss";
</style>
<style lang="scss" >
.custom_chart_tooltip {
    background-color: #ffffff;
    padding: 12px;
    border-radius: 2px;
    border: 0;
    box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px  rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
    .tooltip_title {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 12px;
        color: rgba(0, 0, 0, 0.45);
        p{
            max-width: 120px;
        }
    }
    .tooltip_content {
        margin-top: 12px;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 12px;
        color: rgba(0, 0, 0, 1);
        display: flex;
        justify-content: space-between;
        gap: 24px;
        .count {
            font-weight: 500;
        }
        .chart_circle_item {
            display: flex;
            align-items: center;
            .chart_circle {
                display: inline-block;
                vertical-align: middle;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                margin-right: 9px;
            }
        }
    }
}
</style>
